import React, { useState } from 'react';
import TuvaModal from '@tuva-ui/components/src/TuvaModal';
import ModalService from '../services/Modal.service';
import SocialSignIn from './SocialSignIn';
import '../auth-modal.css';

const modalStyle = {
  // Sign In = mockup `.tuva-modal--sm` (440px), radius-lg (12px). Short content,
  // so it's vertically centered (via `.tuva-auth--signin` in the CSS + the
  // translateY here) rather than top-anchored like the tall Sign Up. Still
  // capped to the viewport with the body scrolling if a very short screen needs
  // it.
  top: '50%',
  bottom: 'auto',
  width: '440px',
  padding: 0,
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  maxHeight: 'calc(100vh - 32px)',
  transform: 'translate(-50%, -50%)',
};

function LoginModal({ onCancel, onSwitchModal, args, isPartner, socialAuth }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [formError, setFormError] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const redirectUrl = args?.redirect_url;
  const userType = args?.userType;
  const locationPath = encodeURIComponent(
    redirectUrl || window.location.pathname,
  );
  const isSubdomain =
    window.SUBDOMAIN !== undefined &&
    window.SUBDOMAIN !== '' &&
    window.SUBDOMAIN !== ' ' &&
    window.SUBDOMAIN !== null;

  function handleSubmit(e) {
    e.preventDefault();
    setFormSubmitted(true);
    setFormError('');

    if (!username.trim() || !password.trim()) return;
    if (isSubmitting) return;
    setIsSubmitting(true);

    ModalService.login(username, password).then(data => {
      if (data.error) {
        setFormError('Something went wrong. Please try again.');
        setIsSubmitting(false);
        return;
      }
      if (data.fail === 1) {
        const errors = data.errors?.__all__ || [];
        setFormError(errors.join('<br>'));
        setIsSubmitting(false);
      } else if (data.redirect || redirectUrl) {
        window.location =
          window.location.protocol +
          '//' +
          window.location.host +
          (redirectUrl || '/' + data.redirect + '/');
      } else {
        setIsSubmitting(false);
      }
    });
  }

  const usernameError =
    formSubmitted && !username.trim() ? 'Enter Email address' : '';
  const passwordError =
    formSubmitted && !password.trim() ? 'Enter Password' : '';

  return (
    <TuvaModal
      isOpen
      onClose={onCancel}
      closeIcon={false}
      safeOverlayClose
      style={modalStyle}
      className="tuva-common-modal tuva-auth tuva-auth--signin"
    >
      {/* Header (shaded) */}
      <div className="tuva-auth__header">
        <div className="flex-1 min-w-0">
          <div className="tuva-auth__title">Sign In to Tuva</div>
          <div className="tuva-auth__subtitle">Welcome back</div>
        </div>
        <button
          type="button"
          aria-label="Close"
          onClick={onCancel}
          className="tuva-auth__close"
        >
          &times;
        </button>
      </div>

      {/* Body */}
      <form onSubmit={handleSubmit} noValidate className="tuva-auth__form">
        <div className="tuva-auth__body">
          <div className="tuva-auth__field">
            <label className="tuva-auth__label">
              Username or Email<span className="tuva-auth__required">*</span>
            </label>
            <input
              className={`tuva-auth__input focus:border-primary ${
                usernameError ? 'is-error' : ''
              }`}
              type="text"
              placeholder="you@school.edu"
              maxLength={254}
              value={username}
              onChange={e => setUsername(e.target.value)}
            />
            {usernameError && (
              <div className="tuva-auth__error">{usernameError}</div>
            )}
          </div>

          <div className="tuva-auth__field !mb-2">
            <label className="tuva-auth__label">
              Password<span className="tuva-auth__required">*</span>
            </label>
            <input
              className={`tuva-auth__input focus:border-primary ${
                passwordError ? 'is-error' : ''
              }`}
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            {passwordError && (
              <div className="tuva-auth__error">{passwordError}</div>
            )}
          </div>

          <button
            type="button"
            className="block ml-auto text-sm font-semibold text-primary hover:underline bg-transparent border-0 p-0 cursor-pointer"
            onClick={() => onSwitchModal('forgot-password')}
          >
            Forgot Password?
          </button>

          {formError && (
            <div
              className="tuva-auth__error mt-2"
              dangerouslySetInnerHTML={{ __html: formError }}
            />
          )}

          <div className="tuva-auth__divider">or sign in with</div>

          <SocialSignIn
            locationPath={locationPath}
            userType={userType}
            action="Sign In"
            partner={isPartner}
            socialAuth={socialAuth}
            variant="grid"
          />
        </div>

        {/* Footer (shaded) with the full-width submit */}
        <div className="tuva-auth__footer">
          <button
            type="submit"
            className="tuva-auth__submit bg-primary hover:bg-primary-hover"
            disabled={isSubmitting}
          >
            Sign In
          </button>
        </div>
      </form>

      {/* Switch to Sign Up */}
      {!isSubdomain && (
        <div className="tuva-auth__switch">
          Don&apos;t have an account?{' '}
          <button
            type="button"
            className="tuva-auth__link text-primary hover:underline"
            onClick={() => onSwitchModal('registration')}
          >
            Sign Up
          </button>
        </div>
      )}
    </TuvaModal>
  );
}

export default LoginModal;
